export default __webpack_public_path__ + "static/media/ess.58572e61.webp";